<template>
  <section class="my-5">
    <h2>登録申込</h2>
    <div class="form-navi my-5">
      <ul class="d-flex flex-wrap">
        <li class="px-3">申込登録</li>
        <li class="px-3">内容確認</li>
        <li class="px-3">商品注文</li>
        <li class="here px-3">カート確認</li>
        <li class="px-3">お届け/お支払</li>
        <li class="px-3">最終確認</li>
        <li class="px-3">申込完了</li>
      </ul>
    </div>
    <h3 class="form-ttl">ご注文確認</h3>
    <p class="exp">以下の内容でよろしければ次へ進むを押してください。</p>

    <div class="detail-cart border box-p-20 mt-5">
      <div class="d-flex py-3 border-bottom only_pc">
        <div class="shohin_group text-center">
          <p>商品</p>
        </div>
        <div class="shohin_quantity text-center">
          <p>個数</p>
        </div>
        <div class="shohin_price text-center">
          <p>価格</p>
        </div>
      </div>
      <div id="CartList">
        <ul>
          <li class="d-flex align-items-center border-bottom">
            <div class="shohin_group d-flex align-items-center my-3">
              <p>1</p>
              <img
                src="/web/contents/products/101/thumb.jpg"
                alt="薬用スキンウォッシュ"
                class="mx-4"
              />
              <p>薬用スキンウォッシュ</p>
            </div>
            <div class="shohin_quantity text-center my-3">
              <select class="w-auto px-3 select_no">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              個 <a href="javascript:void(0)" class="btn ml-3">削除</a>
            </div>
            <div class="shohin_price my-3">
              <p class="text-right">5,250円</p>
            </div>
          </li>
          <li class="d-flex align-items-center border-bottom">
            <div class="shohin_group d-flex align-items-center my-3">
              <p>2</p>
              <img
                src="/web/contents/products/150/thumb.jpg"
                alt="フローラ ファーストセラム"
                class="mx-4"
              />
              <p>フローラ ファーストセラム</p>
            </div>
            <div class="shohin_quantity text-center my-3">
              <select class="w-auto px-3 select_no">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
              </select>
              個 <a href="javascript:void(0)" class="btn ml-3">削除</a>
            </div>
            <div class="shohin_price my-3">
              <p class="text-right">7,350円</p>
            </div>
          </li>
        </ul>
      </div>
      <!-- 動的HTML生成部 カート小計 -->
      <div id="CartSubtotal" class="d-flex my-3">
        <div class="shohin_price_all text-right">
          <p>小計</p>
        </div>
        <div class="shohin_price text-right">
          <p>12,600円</p>
        </div>
      </div>
    <div class="d-flex justify-content-center">
      <router-link
        :to="{ path: '/mock/influencer/order' }"
        class="btn d-inline-block mt-5"
      >
        他の商品を追加する
      </router-link>
    </div>
    </div>
    <div class="d-flex justify-content-center">
      <router-link
        :to="{ path: '/mock/influencer/delivery' }"
        class="btn d-inline-block mt-5"
      >
        次へ進む
      </router-link>
    </div>
  </section>

  <div>
    <p class="text-center">株式会社マナビス化粧品</p>
    <p class="text-center">
      ◆〒279-0032 千葉県浦安市千鳥15-9<br />
      ◆お問い合わせ mc-info@manavis-cosme.co.jp
    </p>
  </div>
</template>

<style scoped>
.cart_set dl {
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cart_set dt {
  width: 300px;
  padding: 10px 15px;
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
  background: #fafafa;
}
.cart_set dd {
  padding: 10px 15px;
  width: calc(100% - 300px);
  border-top: 1px solid #eee;
  border-left: 1px solid #eee;
}
@media screen and (min-width: 1px) and (max-width: 699px) {
  .cart_set dt,
  .cart_set dd {
    width: 100%;
  }
}
</style>


<script>

export default {
  mounted() {
    window.scroll(0, 0);
  }
};

</script>
